const prefix = "[CREATIVES]";

export default {
    FETCH_BOOKINGS_REQUEST: `${prefix} FETCH_BOOKINGS_REQUEST`,
    FETCH_BOOKINGS_SUCCESS: `${prefix} FETCH_BOOKINGS_SUCCESS`,
    FETCH_BOOKINGS_FAILED: `${prefix} FETCH_BOOKINGS_FAILED`,
    UPLOAD_MATERIALS_REQUEST: `${prefix} UPLOAD_MATERIALS_REQUEST`,
    UPLOAD_MATERIALS_SUCCESS: `${prefix} UPLOAD_MATERIALS_SUCCESS`,
    UPLOAD_MATERIALS_FAILED: `${prefix} UPLOAD_MATERIALS_FAILED`,
    FETCH_THIRD_PARTY_SCRIPT_REQUEST: `${prefix} FETCH_THIRD_PARTY_SCRIPT_REQUEST`,
    FETCH_THIRD_PARTY_SCRIPT_SUCCESS: `${prefix} FETCH_THIRD_PARTY_SCRIPT_SUCCESS`,
    FETCH_THIRD_PARTY_SCRIPT_FAILED: `${prefix} FETCH_THIRD_PARTY_SCRIPT_FAILED`,
    SUBMIT_THIRD_PARTY_TAG_REQUEST: `${prefix} SUBMIT_THIRD_PARTY_TAG_REQUEST`,
    SUBMIT_THIRD_PARTY_TAG_SUCCESS: `${prefix} SUBMIT_THIRD_PARTY_TAG_SUCCESS`,
    SUBMIT_THIRD_PARTY_TAG_FAILED: `${prefix} SUBMIT_THIRD_PARTY_TAG_FAILED`,
    SUBMIT_NEW_CREATIVE_THIRD_PARTY_TAG_REQUEST: `${prefix} SUBMIT_TNEW_CREATIVE_HIRD_PARTY_TAG_REQUEST`,
    SUBMIT_NEW_CREATIVE_THIRD_PARTY_TAG_SUCCESS: `${prefix} SUBMIT_NEW_CREATIVE_THIRD_PARTY_TAG_SUCCESS`,
    SUBMIT_NEW_CREATIVE_THIRD_PARTY_TAG_FAILED: `${prefix} SUBMIT_NEW_CREATIVE_THIRD_PARTY_TAG_FAILED`,
    FETCH_VALIDATION_REPORT_REQUEST: `${prefix} FETCH_VALIDATION_REPORT_REQUEST`,
    FETCH_VALIDATION_REPORT_SUCCESS: `${prefix} FETCH_VALIDATION_REPORT_SUCCESS`,
    FETCH_VALIDATION_REPORT_FAILED: `${prefix} FETCH_VALIDATION_REPORT_FAILED`,
    FETCH_PRINT_VALIDATION_REPORT_REQUEST: `${prefix} FETCH_PRINT_VALIDATION_REPORT_REQUEST`,
    FETCH_PRINT_VALIDATION_REPORT_SUCCESS: `${prefix} FETCH_PRINT_VALIDATION_REPORT_SUCCESS`,
    FETCH_PRINT_VALIDATION_REPORT_FAILED: `${prefix} FETCH_PRINT_VALIDATION_REPORT_FAILED`,
    REMOVE_MATERIAL_REQUEST: `${prefix} REMOVE_MATERIAL_REQUEST`,
    REMOVE_MATERIAL_SUCCESS: `${prefix} REMOVE_MATERIAL_SUCCESS`,
    REMOVE_MATERIAL_FAILED: `${prefix} REMOVE_MATERIAL_FAILED`,
    UPDATE_MATERIAL_SPEC_STATUS_REQUEST: `${prefix} UPDATE_MATERIAL_SPEC_STATUS_REQUEST`,
    UPDATE_MATERIAL_SPEC_STATUS_SUCCESS: `${prefix} UPDATE_MATERIAL_SPEC_STATUS_SUCCESS`,
    UPDATE_MATERIAL_SPEC_STATUS_FAILED: `${prefix} UPDATE_MATERIAL_SPEC_STATUS_FAILED`,
    SET_MATERIAL_WORKING_STATUS: `${prefix} SET_MATERIAL_WORKING_STATUS`,
    SET_NEW_MATERIAL_VERSION: `${prefix} SET_NEW_MATERIAL_VERSION`,
    SUBMIT_PRINT_MATERIAL_DESCRIPTION_REQUEST: `${prefix} SUBMIT_PRINT_MATERIAL_DESCRIPTION_REQUEST`,
    SUBMIT_PRINT_MATERIAL_DESCRIPTION_SUCCESS: `${prefix} SUBMIT_PRINT_MATERIAL_DESCRIPTION_SUCCESS`,
    SUBMIT_PRINT_MATERIAL_DESCRIPTION_FAILED: `${prefix} SUBMIT_PRINT_MATERIAL_DESCRIPTION_FAILED`,
    SUBMIT_PRINT_MATERIAL_AD_SERVER_PROPERTIES_REQUEST: `${prefix} SUBMIT_PRINT_MATERIAL_AD_SERVER_PROPERTIES_REQUEST`,
    SUBMIT_PRINT_MATERIAL_AD_SERVER_PROPERTIES_SUCCESS: `${prefix} SUBMIT_PRINT_MATERIAL_AD_SERVER_PROPERTIES_SUCCESS`,
    SUBMIT_PRINT_MATERIAL_AD_SERVER_PROPERTIES_FAILED: `${prefix} SUBMIT_PRINT_MATERIAL_AD_SERVER_PROPERTIES_FAILED`,
    UPDATE_UPLOADED_MATERIAL: `${prefix} UPDATE_UPLOADED_MATERIAL`,
    UPDATE_UPLOADED_MATERIAL_STATUS: `${prefix} UPDATE_UPLOADED_MATERIAL_STATUS`,
    FETCH_MATERIAL_SPEC_REQUEST: `${prefix} FETCH_MATERIAL_SPEC_REQUEST`,
    FETCH_MATERIAL_SPEC_SUCCESS: `${prefix} FETCH_MATERIAL_SPEC_SUCCESS`,
    FETCH_MATERIAL_SPEC_FAILED: `${prefix} FETCH_MATERIAL_SPEC_FAILED`,
    SET_SELECTED_PAGE: `${prefix} SET_SELECTED_PAGE`,
};
